import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { storefront as draw } from '../../../draw';

const normalizeValues = (items = []) =>
  items
    .map((item) => parseFloat(item && item.value))
    .filter((value) => !Number.isNaN(value) && value > 0);

const isStrictlyIncreasing = (values) =>
  values.every((value, index) => index === 0 || value > values[index - 1]);

const Drawing = ({ formContext: { control }, two, twoElem }) => {
  const [widths, elevations] = useWatch({
    control,
    name: ['widths', 'elevations'],
  });

  useEffect(
    () => {
      const normalizedWidths = normalizeValues(widths);
      const normalizedElevations = normalizeValues(elevations);

      if (two && twoElem && twoElem.children[0]) {
        const viewBox = draw({
          two,
          widths: normalizedWidths,
          elevations: isStrictlyIncreasing(normalizedElevations)
            ? normalizedElevations
            : [],
        });
        twoElem.children[0].setAttribute('viewBox', viewBox.join(' '));
      }
    },
    [two, twoElem, widths, elevations]
  );

  return <div id="drawing-container" className="flex-grow-1" />;
};

Drawing.propTypes = {
  formContext: PropTypes.shape({ control: PropTypes.object.isRequired })
    .isRequired,
};

export default Drawing;
